import { obterHtml } from './v2/api';
import { aoExibirPagina, url } from './v2/config';
import { localDaConexao, localEscolhido } from './v2/local';
import { iniciarMedicaoPagina, registrarEvento } from './v2/medicao';
import { avisarErro } from './v2/aviso';
import { ocupar } from './v2/botao';
import { obterUsuario } from './v2/usuario';
import { abrirAlertaDaBusca, alertaPedidoNaUrl, obterAlertaDaBusca } from './v2/alertaJanela';
import { abrirNoSheet, compartilharPagina, fecharCompartilhar, fecharSheet, iniciarVaga } from './v2/vaga';

// Página da profissão (renderProfissao e profSpy da v37). O servidor monta a página inteira com as vagas do Brasil;
// aqui ficam o atalho ativo, "Ler tudo", "e mais N", o "perto de você" (a cidade só o navegador sabe), o alerta, o
// compartilhar e, no celular, a vaga no painel de baixo (o mesmo da busca). No computador o card leva à página da vaga.
const $ = id => document.getElementById(id);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const ehCelular = () => !window.matchMedia('(min-width: 960px)').matches;
const cliqueComum = e => e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;
const lerJson = id => { try { return JSON.parse($(id)?.textContent || 'null'); } catch { return null; } };
const semAnimacao = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const ico = n => `<svg class="ico" aria-hidden="true"><use href="#i-${n}"></use></svg>`;

const P = lerJson('profissao-v2') || {};
const TP = P.textos || {};
const T = lerJson('busca-v2-textos') || {};

// ---------- atalho ativo: a seção que está logo abaixo da barra (o clique segura o destino até a rolagem terminar) ----------
let _segura = null;
let _quadro = 0;
const _alturaFixa = () => Math.max(0, document.querySelector('.site-h')?.getBoundingClientRect().bottom || 0) + (document.querySelector('.emp__nav')?.offsetHeight || 0);

function marcarAtalho() {
    const chips = $$('.emp__chips a').filter(a => a.offsetParent);
    if (!chips.length) {
        return;
    }
    const limite = _alturaFixa() + 24;
    let ativo = chips[0].dataset.profGo;
    if (_segura && Date.now() < _segura.ate) {
        ativo = _segura.id;
    } else {
        chips.forEach(c => {
            const sec = $(c.dataset.profGo);
            if (sec && sec.getBoundingClientRect().top <= limite) {
                ativo = c.dataset.profGo;
            }
        });
        // No fim da página fica marcada a última seção visível.
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
            const visiveis = chips.filter(c => {
                const r = $(c.dataset.profGo)?.getBoundingClientRect();
                return r && r.top < window.innerHeight && r.bottom > limite;
            });
            if (visiveis.length) {
                ativo = visiveis[visiveis.length - 1].dataset.profGo;
            }
        }
    }
    chips.forEach(c => {
        const on = c.dataset.profGo === ativo;
        c.classList.toggle('is-on', on);
        on ? c.setAttribute('aria-current', 'location') : c.removeAttribute('aria-current');
    });
    // No celular a barra rola de lado para o atalho ativo aparecer.
    const on = chips.find(c => c.dataset.profGo === ativo);
    const caixa = on?.parentElement;
    if (on && caixa) {
        const e = on.offsetLeft - caixa.offsetLeft;
        const d = e + on.offsetWidth;
        if (e < caixa.scrollLeft) {
            caixa.scrollLeft = e - 8;
        } else if (d > caixa.scrollLeft + caixa.clientWidth) {
            caixa.scrollLeft = d - caixa.clientWidth + 8;
        }
    }
}

function irParaSecao(id) {
    const sec = $(id);
    if (!sec) {
        return;
    }
    _segura = { id, ate: Date.now() + 700 };
    setTimeout(marcarAtalho, 720);
    marcarAtalho();
    const topo = sec.getBoundingClientRect().top - (_alturaFixa() + 12);
    window.scrollTo({ top: window.scrollY + topo, behavior: semAnimacao() ? 'auto' : 'smooth' });
    sec.setAttribute('tabindex', '-1');
    sec.focus({ preventScroll: true });
}

// ---------- vagas: a lista do Brasil vem no HTML; a da cidade da pessoa, no pedaço ?parcial=vagas ----------
// Os cards que estão na tela (4 no celular, 6 no computador): o painel de baixo anda só por eles.
const idsDaLista = () => $$('#profLista > li[data-id]').filter(li => li.offsetParent).map(li => +li.dataset.id);
let _local = null;
let _controlador = null;
const _pedacos = new Map();

async function carregarVagas(aba, { peloClique = false } = {}) {
    const caixa = $('profVagas');
    if (!caixa || !_local) {
        return;
    }
    const endereco = `${P.caminho}?parcial=vagas&local=${encodeURIComponent(_local.nome)}${_local.origem === 'escolha' ? '&origem=escolha' : ''}${aba === 'brasil' ? '&aba=brasil' : ''}`;
    _controlador?.abort();
    const controlador = new AbortController();
    _controlador = controlador;
    const focoNaAba = document.activeElement?.closest?.('[data-prof-geo]') ? (aba === 'brasil' ? 'nac' : 'local') : null;
    caixa.setAttribute('aria-busy', 'true');
    try {
        const html = _pedacos.get(endereco) ?? await obterHtml(endereco, { sinal: controlador.signal });
        if (_controlador !== controlador) {
            return;
        }
        _pedacos.set(endereco, html);
        caixa.innerHTML = html;
        if (focoNaAba) {
            caixa.querySelector(`[data-prof-geo="${focoNaAba}"]`)?.focus({ preventScroll: true });
        }
    } catch (e) {
        // Sem o pedaço fica a lista que já está na tela; só o clique da pessoa ganha o aviso.
        if (e.name !== 'AbortError' && peloClique) {
            avisarErro(navigator.onLine === false ? TP.semInternet : TP.erroVagas);
        }
    } finally {
        if (_controlador === controlador) {
            caixa.removeAttribute('aria-busy');
        }
    }
}

// Como na home: a cidade escolhida neste aparelho ou a da conexão (Cloudflare), que chega pelo GetUsuarioLogado.
function localDaPessoa() {
    const escolhido = localEscolhido();
    if (escolhido?.tipo === 'cidade' || escolhido?.tipo === 'estado') {
        return { nome: escolhido.nome, origem: 'escolha' };
    }
    const conexao = localDaConexao();
    return conexao ? { nome: conexao.nome, origem: 'conexao' } : null;
}

// ---------- alerta (o da busca: o cargo é o nome da profissão, sem local) ----------
let _logado = false;
let _alertaDaProfissao = null;
let _abrindoAlerta = false;
const _alertaNaChegada = alertaPedidoNaUrl();

function desenharAlerta() {
    if (!_logado) {
        return;
    }
    const al = _alertaDaProfissao?.cobre ? _alertaDaProfissao.alerta : null;
    $$('.js-prof-alerta').forEach(b => {
        b.setAttribute('aria-haspopup', 'dialog');
        b.classList.toggle('is-on', !!al && !al.pausado);
        // Pausado não manda e-mail: aparece desligado.
        b.innerHTML = al
            ? `${ico(al.pausado ? 'bell' : 'bell-fill')}${esc(TP.alertaVagas)} <span class="st">${esc(al.pausado ? T.alertaDesligado : T.alertaLigado)}</span>`
            : `${ico('bell')}${esc(T.criarAlerta)}`;
    });
}

async function carregarAlerta() {
    try {
        _alertaDaProfissao = await obterAlertaDaBusca(P.alerta, '');
    } catch {
        _alertaDaProfissao = null;
    }
    desenharAlerta();
}

// A janela já preenchida: o alerta que já tem a profissão, para editar, ou um novo com ela.
async function abrirAlerta(botao) {
    if (_abrindoAlerta) {
        return;
    }
    // Um toque de cada vez (o segundo, antes de a janela abrir, a abriria de novo).
    _abrindoAlerta = true;
    ocupar(botao);
    let saindo = false;
    const irAoLogin = () => {
        saindo = true;
        const p = new URLSearchParams(window.location.search);
        p.set('alerta', '1');
        window.location.href = url(`/login?ReturnUrl=${encodeURIComponent(`${window.location.pathname}?${p}`)}`);
    };
    try {
        // O clique pode vir antes de o GetUsuarioLogado responder: quem está logado não vai para o login.
        _logado = !!(await obterUsuario())?.logado;
        if (!_logado) {
            irAoLogin();
            return;
        }
        const abriu = await abrirAlertaDaBusca(P.alerta, '', {
            gatilho: botao,
            aoMudar: ({ novo }) => {
                if (novo) {
                    registrarEvento('alerta_criado', { origem: 'profissao' });
                }
                carregarAlerta();
            }
        });
        if (!abriu) {
            irAoLogin();
        }
    } catch {
        avisarErro(T.erroAlerta);
    } finally {
        _abrindoAlerta = false;
        if (!saindo) {
            ocupar(botao, false);
        }
    }
}

// ---------- visualização e origem (o profissoes-detalhes.js do v1) ----------
function origem() {
    const q = new URLSearchParams(window.location.search);
    return document.referrer.split('/')[2] || q.get('source') || q.get('utm_source') || '';
}

function dispositivo() {
    const ua = navigator.userAgent;
    if (/Tablet|iPad/i.test(ua)) {
        return 'Tablet';
    }
    return /Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i.test(ua) ? 'Mobile' : 'Desktop';
}

function salvarVisualizacao() {
    const dados = new FormData();
    dados.append('ProfissaoID', P.id);
    dados.append('Origem', origem());
    dados.append('Url', window.location.hostname);
    dados.append('Dispositivo', dispositivo());
    // A resposta é texto ("true"), não JSON.
    fetch(url('/Profissao/SalvarVisualizacao'), { method: 'POST', body: dados, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } }).catch(() => {});
}

// Origem da campanha (?campanha ou ?source): o cookie que o cadastro e a candidatura leem, por 1 dia, cru como no v1.
function definirOrigemCadastro() {
    const q = new URLSearchParams(window.location.search);
    const campanha = q.get('campanha') || q.get('source');
    if (campanha) {
        document.cookie = `origemCadastro=${campanha}; expires=${new Date(Date.now() + 864e5).toUTCString()}; path=/`;
    }
}

// ---------- eventos ----------
function iniciarEventos() {
    document.addEventListener('click', e => {
        const t = e.target;

        const atalho = t.closest('[data-prof-go]');
        if (atalho && cliqueComum(e)) {
            e.preventDefault();
            irParaSecao(atalho.dataset.profGo);
            return;
        }

        // No celular a vaga abre no painel de baixo, igual à busca; no computador o link leva à página da vaga.
        const card = t.closest('#profLista a[data-vaga]');
        if (card && cliqueComum(e) && ehCelular()) {
            e.preventDefault();
            abrirNoSheet(+card.dataset.vaga);
            return;
        }

        const geo = t.closest('[data-prof-geo]');
        if (geo) {
            if (geo.getAttribute('aria-selected') !== 'true') {
                carregarVagas(geo.dataset.profGeo === 'nac' ? 'brasil' : 'local', { peloClique: true });
            }
            return;
        }

        const lerTudo = t.closest('[data-prof-mais]');
        if (lerTudo) {
            const texto = $(lerTudo.getAttribute('aria-controls'));
            const abrir = lerTudo.getAttribute('aria-expanded') !== 'true';
            texto?.classList.toggle('is-clamp', !abrir);
            lerTudo.setAttribute('aria-expanded', String(abrir));
            lerTudo.textContent = abrir ? TP.mostrarMenos : TP.lerTudo;
            return;
        }

        if (t.closest('[data-prof-sin]')) {
            const sin = $('profSin');
            sin?.classList.add('is-all');
            sin?.focus({ preventScroll: true });
            return;
        }

        const alerta = t.closest('.js-prof-alerta');
        if (alerta) {
            abrirAlerta(alerta);
            return;
        }

        const compartilhar = t.closest('.js-prof-share');
        if (compartilhar) {
            compartilharPagina({
                link: P.url,
                titulo: P.nome,
                texto: TP.compartilhar,
                linha: P.linha,
                logo: `<span class="card__logo" aria-hidden="true">${ico('briefcase')}</span>`,
                rotuloLink: TP.linkPagina,
                cabecalho: TP.compartilharTitulo
            }, compartilhar);
        }
    });

    document.addEventListener('keydown', e => {
        // Abas "Onde": as setas trocam, como na home.
        const aba = e.target.closest?.('[data-prof-geo]');
        if (aba) {
            const abas = $$('[data-prof-geo]', aba.parentElement);
            const i = abas.indexOf(aba);
            const destino = { ArrowRight: (i + 1) % abas.length, ArrowLeft: (i - 1 + abas.length) % abas.length, Home: 0, End: abas.length - 1 }[e.key];
            if (destino !== undefined) {
                e.preventDefault();
                // O tabindex muda antes do foco: com -1 a aba ficaria sem o contorno até a lista nova chegar (ou sem ele, se falhar).
                abas.forEach((a, j) => { a.tabIndex = j === destino ? 0 : -1; });
                abas[destino].focus();
                abas[destino].click();
                return;
            }
        }
        if (e.key === 'Escape' && !document.querySelector('dialog[open]')) {
            if (fecharCompartilhar()) {
                return;
            }
            const aberto = $$('.sheet.is-open:not(#sheetMenu)').pop();
            if (aberto) {
                fecharSheet(aberto);
            }
        }
    });

    window.addEventListener('scroll', () => {
        if (_quadro) {
            return;
        }
        _quadro = requestAnimationFrame(() => {
            _quadro = 0;
            marcarAtalho();
        });
    }, { passive: true });
}

// A introdução só fica recolhida no celular quando passa de 5 linhas: curta, o "Ler tudo" sai.
function conferirIntroducao() {
    const intro = $('pft-intro');
    const botao = document.querySelector('[data-prof-mais="intro"]');
    if (intro && botao && ehCelular() && intro.classList.contains('is-clamp') && intro.scrollHeight <= intro.clientHeight + 1) {
        intro.classList.remove('is-clamp');
        botao.hidden = true;
    }
}

// ---------- início ----------
iniciarMedicaoPagina('profissao');
// Pré-renderizada pelo app: a origem da campanha e a visita só valem quando a pessoa abre a tela.
aoExibirPagina(() => {
    definirOrigemCadastro();
    salvarVisualizacao();
});
iniciarVaga({
    textos: T,
    itens: '#profLista li',
    lista: idsDaLista,
    total: () => idsDaLista().length,
    temMais: () => false,
    carregarMais: async () => false
});
iniciarEventos();
marcarAtalho();
conferirIntroducao();
document.fonts?.ready.then(conferirIntroducao);

(async () => {
    const u = await obterUsuario();
    _logado = !!u?.logado;
    if (_logado && $$('.js-prof-alerta').length) {
        await carregarAlerta();
        if (_alertaNaChegada) {
            abrirAlerta($$('.js-prof-alerta')[0]);
        }
    }
    _local = localDaPessoa();
    if (_local) {
        await carregarVagas('local');
        // A vaga da volta pode ser da lista da cidade, que só chega agora.
        abrirVagaDaVolta();
    }
})();

// Volta do login com ?vaga= no celular (sem armazenamento, o login usa o ReturnUrl): a vaga abre de novo por cima da lista.
function abrirVagaDaVolta() {
    const id = +new URLSearchParams(window.location.search).get('vaga');
    if (!id || !ehCelular() || !idsDaLista().includes(id)) {
        return;
    }
    document.querySelector(`#profLista > li[data-id="${id}"]`)?.scrollIntoView({ block: 'center' });
    // O vaga.js já leu o "confirmar" ao iniciar: os dois saem do endereço que fica embaixo do painel.
    const u = new URL(window.location.href);
    u.searchParams.delete('vaga');
    u.searchParams.delete('confirmar');
    history.replaceState(history.state, '', u.pathname + u.search);
    abrirNoSheet(id);
}
abrirVagaDaVolta();
